import { useEffect, useState } from 'preact/hooks';

export default function useDarkModePreference(fallback = false) {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const [prefersDarkMode, setDarkModePreference] = useState(mediaQuery?.matches || fallback);

    useEffect(() => {
        const handler = $e => setDarkModePreference($e.matches);
        mediaQuery.addEventListener('change', handler);

        return () => mediaQuery.removeEventListener('change', handler); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return prefersDarkMode;
}
